export default __webpack_public_path__ + "static/media/businesscase-pop.b0878ec8.svg";